// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2NGOs","requiredAsterisk":"Info_requiredAsterisk__LfiZg"};